export const getHariLong = (dateString) => {
    const date = new Date(dateString);
    const options = { weekday: 'long' };
    return date.toLocaleDateString('ms-MY', options);
};

export const getTarikh = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ms-MY', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    });
};

export const getSubjek = (subjectId) => {
    const subjects = {
        1: 'Tauhid',
        2: 'Fekah',
        3: 'Hadis',
        4: 'Tafsir',
        5: 'Umum',
    };
    return subjects[subjectId] || 'Umum';
};

export const formatCustomDate = (dateString) => {
    const date = new Date(dateString);
    const dayNames = ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'];
    const monthNames = ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'];
    const day = dayNames[date.getDay()];
    const dayOfMonth = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;

    return `${day}, ${dayOfMonth} ${month} ${year}, ${hours}:${minutesStr} ${ampm}`;
};

// src/utils/formatHelpers.js

// Roman numeral (I, II, III, IV, ...), case-insensitive
const ROMAN_RE =
    /^(?=[MDCLXVI])M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/i;

const smartCapWord = (raw = "") => {
    if (!raw) return "";

    // keep punctuation depan/belakang (contoh: "(III)", "III,", "III.")
    const m = String(raw).match(/^([^A-Za-z0-9]*)([A-Za-z0-9]+)([^A-Za-z0-9]*)$/);
    if (!m) return raw;

    const [, pre, core, post] = m;

    // ✅ Roman numeral → UPPERCASE
    if (ROMAN_RE.test(core)) return `${pre}${core.toUpperCase()}${post}`;

    // optional: kalau semua huruf besar (akronim) kekalkan
    // contoh: "JKR", "ABIM", "TVET"
    if (core.length >= 2 && core === core.toUpperCase()) return `${pre}${core}${post}`;

    // normal title case
    return `${pre}${core.charAt(0).toUpperCase()}${core.slice(1).toLowerCase()}${post}`;
};

export const capitalizeWords = (s = "") => {
    return String(s || "")
        .trim()
        .split(/\s+/)
        .map((w) =>
            // support perkataan ber-hyphen: "Al-Falah", "Sultan-Muhammad"
            w.split("-").map(smartCapWord).join("-")
        )
        .join(" ");
};
